// Components/Banner/CreateBanner.jsx
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/features/modalSlice";
import { successToast, errorToast } from "../../Utils/toast";
import { useCreateBannerMutation } from "../../redux/services/bannerService/banner.Services";

function CreateBanner({ refreshData }) {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    status: "active",
    link: "",
    image: null,
  });
  
  const [createBanner, { isLoading }] = useCreateBannerMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        image: file,
      });
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.name) {
      errorToast("Banner name is required");
      return;
    }
    if (!formData.image) {
      errorToast("Banner image is required");
      return;
    }

    try {
      const form = new FormData();
      form.append("name", formData.name);
      form.append("description", formData.description);
      form.append("status", formData.status);
      form.append("link", formData.link);
      form.append("image", formData.image);

      const res = await createBanner(form).unwrap();
      successToast(res?.message || "Banner Created Successfully 🚀");
      refreshData?.();
      dispatch(closeModal());
    } catch (error) {
      console.log(error);
      errorToast(error?.data?.message || "Error Creating Banner ❌");
    }
  };

  return (
    <div className="create-banner-wrapper">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Banner Name *</label>
          <input
            type="text"
            name="name"
            className="form-control"
            placeholder="Enter Banner Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            name="description"
            className="form-control"
            rows="4"
            placeholder="Enter Description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Link</label>
          <input
            type="url"
            name="link"
            className="form-control"
            placeholder="https://example.com"
            value={formData.link}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Status</label>
          <select
            name="status"
            className="form-select"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Banner Image *</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handleImageChange}
            required
          />
        </div>

        {preview && (
          <div className="mb-3">
            <img
              src={preview}
              alt="Preview"
              style={{
                width: "120px",
                borderRadius: "10px",
                border: "1px solid #ddd",
                padding: "5px",
              }}
            />
          </div>
        )}

        <div className="d-flex gap-2">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {isLoading ? "Creating..." : "Create Banner"}
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => dispatch(closeModal())}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateBanner;